const reduceToDecimalPlacesValue = 2;
export const reduceToFixedDecimals = (amount) => {
  if (isNaN(amount)) return amount;
  return Number(Number(amount).toFixed(reduceToDecimalPlacesValue));
};
